<!--Footer Starts-->
<footer class="footer">
  <p class="copyright clearfix text-muted m-0">
    Copyright &copy; {{currentDate | date: 'yyyy'}} <a id="pixinventLink"
      href="javascript:window.open('https://www.contazz.com.br/')">Contazz</a>
    <span class="d-none d-sm-inline-block">, todos os direitos reservados.</span> 
    <a href="javascript:window.open('https://contazz.s3.dualstack.sa-east-1.amazonaws.com/file/TERMOS-DE-USO_CONTAZZ-1-2025.pdf')" style="float: right;">Termos de Uso</a>
  </p>
</footer>
<!--Footer Ends-->
